import { render, staticRenderFns } from "./JuHui.vue?vue&type=template&id=6f8583ae&"
import script from "./JuHui.vue?vue&type=script&lang=js&"
export * from "./JuHui.vue?vue&type=script&lang=js&"
import style0 from "./JuHui.vue?vue&type=style&index=0&id=6f8583ae&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports